import React, { useEffect } from "react";
import { BiHeart } from "react-icons/bi";

function UpcomingGridView({ datas }) {
  useEffect(() => {
    window.scroll(0, 0);
  }, []);
//   console.log(datas.sort(()=>.5- Math.random()))
  return (
    <div className="adjustGrid">
      {datas.sort(()=>.5 - Math.random()).map((e, index) => {
        return (
          <div className="cardFeatured" key={index}>
            <div className="position-relative">
              <div className="mainImage">
                <img src={e.mainImg} alt="card" />
              </div>
              <div className="profileImages">
                <img src={e.profileImg} alt="profile" />
              </div>
              <div className="timeStamp">02h 48m 55s</div>
            </div>
            <div className="cardNames">
              {e.profileName}
              <img src="signed 1.png" alt="tick" className="tick ms-2" />
            </div>
          </div>
        );
      })}
    </div>
  );
}

export default UpcomingGridView;
